import styled from 'styled-components';
import {
  Circle as CircleStyle, Fill, Stroke, Style, Text,
} from 'ol/style';
import { green } from '../../styles/constants';

export const StyledContainer = styled.div`
  min-height: 100vh;
  display: grid; // todo: find out why this works
`;

export const Toolbar = styled.div`
  display: ${(props) => (props.show ? 'block' : 'none')};
  position: absolute;
  z-index: 99;
  bottom: 20px;
  width: 100%;
`;

export const vectorLayerStyle = new Style({
  fill: new Fill({
    color: 'rgba(0,160,80,0.3)',
  }),
  stroke: new Stroke({
    color: green,
    width: 2,
  }),
});

export const polygonStyle = new Style({
  fill: new Fill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new Stroke({
    color: green,
    width: 2,
  }),
  image: new CircleStyle({
    radius: 5,
    stroke: new Stroke({
      color: 'white',
    }),
    fill: new Fill({
      color: green,
    }),
  }),
});

export const pointStyle = new Style({
  image: new CircleStyle({
    radius: 5,
    fill: new Fill({color: 'green'}),
    stroke: new Stroke({
      color: 'white',
      width: 1,
    }),
  }),
  text: new Text({
    text: 'Klik op dit punt om de polygoon te sluiten',
    offsetY: -15,
    scale: 1.2,
    fill: new Fill({color: 'black'}),
  }),
});
